var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',{staticClass:"body-2 whitespace-pre-wrap break-all",domProps:{"innerHTML":_vm._s(_vm.description)}})}
var staticRenderFns = []

export { render, staticRenderFns }